import { render } from "./CheRry.vue?vue&type=template&id=2621a220"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/CheRry.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2621a220"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2621a220', __exports__)) {
    api.reload('2621a220', __exports__)
  }
  
  module.hot.accept("./CheRry.vue?vue&type=template&id=2621a220", () => {
    api.rerender('2621a220', render)
  })

}


export default __exports__